import { ApiOptions } from "../types";

export const DefaultFirefoxRelayOptions: ApiOptions = Object.freeze({
  website: null,
  token: "",
});
